/* @flow */
/* eslint-disable babel/no-invalid-this */
import UserCodeCollection from "nexia_mobile/models/user_code_collection";
import type { AccessCodeFeature } from "./types";

export default function AccessCode(feature: AccessCodeFeature) {
  const setTemporaryAction = feature.actions.set_temporary;
  const removeTemporaryAction = feature.actions.remove_temporary;

  if (feature.resource && !this._accessCodes) {
    this._accessCodes = new UserCodeCollection();
    this._accessCodes.setUrl(feature.resource.href);
  }

  this.getAccessCodes = () => {
    return this._accessCodes;
  };

  this.getAccessCodeLength = () => feature.code_length;

  this.hasTemporaryAccessCode = () => feature.has_temporary;

  this.setTemporaryAccessCode = (value) => {
    const name = this.get("name");
    return this.executeDeviceAction(
      setTemporaryAction,
      { code: value },
      { message: `Setting temporary code for ${name}` }
    );
  };

  this.removeTemporaryAccessCode = () => {
    const name = this.get("name");
    return this.executeDeviceAction(
      removeTemporaryAction,
      {},
      {
        message: `Removing temporary code from ${name}`,
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/access_code.js